export default __webpack_public_path__ + "static/media/minus-black.e0640482.svg";